import React from "react";

export default function CreateVehicleAccessory() {
  return (
    <div className="createvehicleaccessory-container my-4">
      <div className="col-md-12">
        <div className="special-header panel-white-all">
          <h4 className="page-title">Create Vehicle Accessory</h4>
        </div>

        <form>
          <div className="row create-vehicle-accessory">
            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="vehicleno" className="form-label"> Vehicle Number <span className="text-danger">*</span></label>
              <select id="vehicleno" className="form-control createaccessory-form-select" >
                <option>Select</option>
                <option>MH21WE9021</option>
                <option>MH02WE0002</option>
                <option>MH03BR8934</option>
              </select>
            </div>
           <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="accessory" className="form-label">Accessory Item<span className="text-danger">*</span>  </label>
              <input type="text" id="accessory" className="form-control createaccessory-form-control"  />
            </div>


            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="quantity" className="form-label">Quantity<span className="text-danger">*</span>  </label>
              <input type="text" id="quantity" className="form-control createaccessory-form-control" placeholder="Enter fuel quantity" />
            </div>

            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="price" className="form-label"> Price <span className="text-danger">*</span> </label>
              <input type="text" id="price" className="form-control createaccessory-form-control" placeholder="Enter amount" />
            </div>

            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="amount" className="form-label"> Purchase Form <span className="text-danger">*</span> </label>
              <input type="text" id="amount" className="form-control createaccessory-form-control" placeholder="Enter amount" />
            </div>

            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="date" className="form-label">Purchase Date<span className="text-danger">*</span></label>
              <input  type="date"  id="date"  className="form-control createaccessory-form-control" />
            </div>
           
           <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="file" className="form-label">Invoice<span className="text-danger">*</span></label>
              <input  type="file"  id="file"  className="form-control createaccessory-form-control" />
            </div>

            <div className="col-lg-12 col-md-12 mt-3 d-flex justify-content-end">
              <button type="submit" className="btn custom-btn">
                Create
              </button>
            </div>
            
          </div>
        </form>
      </div>
    </div>
  
    
  );
}
